import { format } from 'date-fns';
import { getAgeFromIsoDate, parseIsoDateSafe } from '@/utils/parseIsoDateSafe';

export const formatDateOfBirth = (
  dateString: string | null | undefined,
  options?: { withAge?: boolean; ageFormat?: 'short' | 'long' }
): string => {
  if (!dateString) {
    return '-';
  }

  const date = parseIsoDateSafe(dateString);

  if (!date) {
    return dateString;
  }

  let formattedDate: string;

  try {
    formattedDate = format(date, 'MMM d, yyyy');
  } catch {
    return dateString;
  }

  const age = getAgeFromIsoDate(dateString);

  if (options?.withAge && age !== null) {
    switch (options.ageFormat) {
      case 'long':
        return `${formattedDate}, Age: ${age} years`;
      case 'short':
        return `${formattedDate} (${age})`;
      default:
        return `${formattedDate} (${age})`;
    }
  }

  return formattedDate;
};
